import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { hiddenLoader } from "../stores/loading";
import { fetchAPI } from "../utils/api";
import { Form } from "./form/Form";
import { Table } from "./table/Table";

export default function Commission() {
    const dispatch = useDispatch();
    const [transferStatus, setTransferStatus] = useState([] as any);
    const [refillStatus, setRefillStatus] = useState([] as any);
    const [payoutStatus, setPayoutStatus] = useState([] as any);
    const [operators, setOperators] = useState([] as any);
    const [type, setType] = useState([] as any);
    const [formState, setFormState] = useState({} as any);
    const [filterState, setFilterState] = useState('' as string);
    const [resultCommissions, setResultCommissions] = useState([] as any);
    const [page, setPage] = useState(0 as any);

    useEffect(() => {
        fetchAPI("/commissions/statuses")
            .then((res) => res.json())
            .then(( result) => {
                setTransferStatus(result.TRANSFER_STATUS)
                setRefillStatus(result.REFILL_STATUS)
                setPayoutStatus(result.PAYOUT_STATUS)
                setType(result.TYPE)
            });
        fetchAPI("/operators")
            .then((res) => res.json())
            .then(setOperators);
    }, []);

    function search(form: any, page: number = 0) {
        if ( !page ) {
            setFilterState('');
        }
        setPage(page)
        setFormState(form);
        fetchAPI(`/commissions/search?page=${page}&size=15${filterState}`, {
            method: "POST",
            body: JSON.stringify(form)
        })
            .then((res) => {
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    return res.json()
                }
                dispatch(hiddenLoader());
                return res;
            })
            .then(setResultCommissions);

    }

    function filterResult(form: any, filter: any) {
        setFormState(form);
        setFilterState(filter);
        fetchAPI(`/commissions/search?page=0&size=15${filter}`, {
            method: "POST",
            body: JSON.stringify(form)
        })
            .then((res) => {
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    return res.json()
                }
                dispatch(hiddenLoader());
                return res;
            })
            .then(setResultCommissions);

    }

    function update(commission: any) {
        fetchAPI(`/commissions/${commission.id}`, {
            method: "PATCH",
            body: JSON.stringify({operator : commission.operator_name})
        })
            .then((res) => {
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    return res.json()
                }
                dispatch(hiddenLoader());
                return res;
                
            })
            .then(() => search(formState, page));
    }

    function reset() {
        setResultCommissions([])
    }

    let form = {
        "start_date": "datetime",
        "thru_date": "datetime",
        "operator_event_start_date": "datetime",
        "operator_event_thru_date": "datetime",
        "operators": {
            type: 'multiple', value: operators.length > 0 ? operators.map((v: any) => v.name) : []
        },
        "producer": "string",
        "order_id": "string",
        "commission_id": "string",
        "invoice_id": "string",
        "transfer_status": {
            type: 'multiple', value: transferStatus ? transferStatus.map((v : any) => v.value) : []
        }
    }

    let formHiden = {
        "refill_status": {
            type: 'multiple', value: refillStatus ? refillStatus.map((v : any) => v.value) : []
        },
        "payout_status": {
            type: 'multiple', value: payoutStatus ? payoutStatus.map((v : any) => v.value) : []
        },
        "types": {
            type: 'multiple', value: type ? type.map((v : any) => v.value) : []
        },
        "escrow_transfer_id": "string",
        "operator_transfer_id": "string",
        "producer_transfer_id": "string",
        "operator_payout_id": "string",
        "producer_payout_id": "string"
    }

    let headers = [
        "id",
        "producer_uid",
        "mapper_invoice",
        "type",
        "transfer_status",
        "payout_status",
        "refill_status",
        "amount",
        "operator_event_date"
    ]

    let sortable = [
        "id",
        "amount",
        "type",
        "transfer_status",
        "payout_status",
        "refill_status"
    ]
    let details = [
        "order_id",
        "item_id",
        "operator_name",
        "operator_transfer_id",
        "producer_transfer_id",
        "escrow_transfer_id",
        "escrow_transfer_start_date",
        "escrow_transfer_thru_date",
        "operator_payout_id",
        "operator_payout_date",
        "producer_payout_id",
        "producer_payout_date",
        "currency",
        "created_date",
        "mapper_id",
        "producer_part",
        "operator_part",
        "operator_vat_amount",
        "operator_vat_rate"
    ]

    let clickables = {
        "mapper_invoice": "/invoice?invoice_id="
    }

    let tooltips = {
        refill_status : refillStatus,
        payout_status : payoutStatus,
        type : type,
        transfer_status : transferStatus
    }

    return (<>
        <div className="vtmn-p-4">
            <Form
                form={form}
                search={(form: any, page: number) => search(form)}
                formHiden={formHiden}
                reset={() => reset()}
            />
        </div>
        <div>
            {resultCommissions?.content?.length > 0 &&
                <Table
                    update={true}
                    sortable={sortable}
                    result={resultCommissions}
                    tooltips={tooltips}
                    headers={headers}
                    details={details}
                    clickables={clickables}
                    changePage={(page: number) => search(formState, page)}
                    filterResult={(filter: string) => filterResult(formState, filter)}
                    FormUpdate={(v: any) => FormUpdateProducer({...v, update, operators : form.operators.value})}
                />}
            {resultCommissions.status === 404 && <p className="vtmn-text-center">No Result</p>}
        </div>
    </>
    )
}

export function FormUpdateProducer({fieldSelected, setFieldSelected, update, operators} : any) {

    const [operatorName, setOperatorName] = useState(fieldSelected.operator_name as string);
 
    function functionUpdate(value: any) {
        update({...value, operator_name : operatorName});
        setFieldSelected(null);
    }

    return (<>
        <div className="vtmn-modal_content_body">
            <div className="vtmn-grid vtmn-grid-cols-1 vtmn-gap-0 vtmn-mb-2" >
            <div className="block">Id : {fieldSelected.id}</div>
            <div className="block">Producer uid : {fieldSelected.producer_uid}</div>
            <div className="block">Mapper invoice : {fieldSelected.mapper_invoice}</div>
            <div className="block">Type : {fieldSelected.type}</div>
            <div className="block">Transfer status : {fieldSelected.transfer_status}</div>
            <div className="block">Payout_status : {fieldSelected.payout_status}</div>
            <div className="block">Refill_status : {fieldSelected.refill_status}</div>
            <div className="block">Amount : {fieldSelected.amount}</div>
            <div className="block">Operator event date : {fieldSelected.operator_event_date}</div>
            <div className="block">Order id : {fieldSelected.order_id}</div>
            <div className="block">Item id : {fieldSelected.item_id}</div>
            <div className="block">Operator name : 
                { fieldSelected.type === 'FEE' && <select name="status" id="status-select" onChange={(e) => setOperatorName(e.target.value)}>
                <option value={operatorName}>{fieldSelected.operator_name}</option>
                {operators.sort().map((op: string) => {
                    return <option key={op} value={op}>{op}</option>
                })}
                </select>} 
                { fieldSelected.type !== 'FEE' &&
                <>{fieldSelected.type}</>
                }
            </div>
            <div className="block">Operator transfer id : {fieldSelected.operator_transfer_id}</div>
            <div className="block">Producer transfer id : {fieldSelected.producer_transfer_id}</div>
            <div className="block">Escrow transfer id : {fieldSelected.escrow_transfer_id}</div>
            <div className="block">Escrow transfer start date : {fieldSelected.escrow_transfer_start_date}</div>
            <div className="block">Escrow transfer thru date : {fieldSelected.escrow_transfer_thru_date}</div>
            <div className="block">Operator payout id : {fieldSelected.operator_payout_id}</div>
            <div className="block">Producer payout id : {fieldSelected.producer_payout_id}</div>
            <div className="block">Currency : {fieldSelected.currency}</div>
            <div className="block">Created date : {fieldSelected.created_date}</div>
            <div className="block">Mapper id : {fieldSelected.mapper_id}</div>
            <div className="block">Producer part : {fieldSelected.producer_part}</div>
            <div className="block">Operator part : {fieldSelected.operator_part}</div>
            <div className="block">Operator vat amount : {fieldSelected.operator_vat_amount}</div>
            <div className="block">Operator vat rate : {fieldSelected.operator_vat_rate}</div>
            </div>
        </div>
        <div className="vtmn-modal_content_actions">
          <button className="vtmn-btn vtmn-btn_variant--secondary" onClick={() => setFieldSelected(null)}>Close</button>
          <button className="vtmn-btn vtmn-btn_variant--primary" onClick={() => functionUpdate(fieldSelected)}>
            Save
          </button>
        </div>
    </>
    )
}
